// The model seam. CloudProvider (Anthropic Claude) is the only adapter built;
// the interface stays swappable so a different cloud model slots in without
// caller changes. No local adapter is built.

export interface LLMMessage {
  role: "user" | "assistant";
  content: string;
}

export interface CompleteOptions {
  system: string;
  messages: LLMMessage[];
  maxTokens?: number;
  temperature?: number;
}

export interface LLMProvider {
  // Whether a usable configuration exists (a proxy URL, or a BYO key).
  isConfigured(): Promise<boolean>;
  // Resolves to the model's text. Throws LLMUnavailable on any failure so the
  // UI can degrade gracefully rather than wedge.
  complete(opts: CompleteOptions): Promise<string>;
}

export class LLMUnavailable extends Error {
  constructor(message: string) {
    super(message);
    this.name = "LLMUnavailable";
  }
}
